import React, { useState, useEffect } from 'react';
import cx from 'classnames';
const MenuItem = ({ menuItem, highlightMenuItem, isSelected, onClickEvent, }) => {
    const { id, name, children } = menuItem;
    return (React.createElement("div", { key: id, className: cx('menubar-item', {
            'menubar-item__selected': highlightMenuItem && id === isSelected.id,
        }) },
        React.createElement("button", { className: "menubar-item__content", onClick: e => onClickEvent(e, menuItem) }, name),
        children ? (React.createElement("div", { className: "menubar-item__children" }, children.map(child => (React.createElement(MenuItem, { menuItem: child, highlightMenuItem: highlightMenuItem, isSelected: isSelected, onClickEvent: onClickEvent, key: child.id }))))) : null));
};
export const SideBarMenu = ({ content, className = 'side-bar-menu', onSelect, isSelectedItemCancelled = null, previousSelectedItem = content[0], changesAvailable = false, setIsSelectedItemCancelled = () => { }, highlightMenuItem = true, }) => {
    const [isSelected, isSetSelected] = useState(content[0]);
    const [nextSelected, setNextSelected] = useState(content[0]);
    useEffect(() => {
        if (isSelectedItemCancelled === null) {
            return;
        }
        if (isSelectedItemCancelled) {
            isSetSelected(previousSelectedItem);
        }
        else {
            isSetSelected(nextSelected);
        }
        setIsSelectedItemCancelled(null);
    }, [isSelectedItemCancelled]);
    if (typeof content === 'undefined' && !content) {
        return null;
    }
    const menuElements = content.map((item) => {
        const onClickEvent = (e, item) => {
            e.stopPropagation();
            if (onSelect) {
                onSelect(item);
            }
            if (!changesAvailable) {
                isSetSelected(item);
            }
            else {
                setNextSelected(item);
            }
        };
        return (React.createElement(MenuItem, { menuItem: item, highlightMenuItem: highlightMenuItem, isSelected: isSelected, onClickEvent: onClickEvent, key: item.id }));
    });
    return React.createElement("div", { className: className }, menuElements);
};
//# sourceMappingURL=SideBarMenu.js.map